import { z } from 'zod';
import { LEVELS, ROLES, CATEGORIES, define, DEFINITION_KINDS } from '../types.js';

/**
 * Move type values.
 */
export const MoveTypes = ['concierge', 'concierge-loaner', 'one-way', 'round-trip'];

/**
 * Move type schema.
 */
export const MoveTypeSchema = z.enum(MoveTypes as [string, ...string[]]);

export type MoveType = z.infer<typeof MoveTypeSchema>;

/**
 * Default move type pre-selected for new moves.
 */
export const schema = MoveTypeSchema;

export type DefaultMoveType = z.infer<typeof schema>;

export const definition = define({
  key: 'default_move_type',
  schema,
  label: 'Default Move Type',
  description: 'Default move type pre-selected for new moves. Users can change, but this sets initial selection.',
  kind: DEFINITION_KINDS.SETTING,
  category: CATEGORIES.MOVE_PLANNING.key,
  writableAtLevels: [
    LEVELS.HOPDRIVE,
    LEVELS.REGION,
    LEVELS.ORGANIZATION,
    LEVELS.CUSTOMER,
    LEVELS.WORKFLOWSET,
    LEVELS.RATERULEGROUP,
  ],
  readableByRoles: [ROLES.ADMIN],
  defaultValue: 'concierge',
});
